import { useState } from 'react';

import { SearchOutlined } from '@lichtblick/icons';

import { Container } from './SearchInput.styles';

import { IconButton } from '../IconButton';
import { TextInput } from '../TextInput';

type SearchInputProps = {
  onSubmit: (value: string | undefined) => void;
  placeholder?: string;
  value: string | undefined;
};

export const SearchInput = ({ onSubmit, placeholder, value }: SearchInputProps) => {
  const [controlValue, setControlValue] = useState<string | undefined>(value);

  return (
    <Container>
      <TextInput
        onChange={(e) => {
          setControlValue(e.currentTarget.value);
        }}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === 'Enter') {
            onSubmit(controlValue);
          }
        }}
        placeholder={placeholder ?? ''}
        value={controlValue}
      />
      <IconButton icon={<SearchOutlined />} onClick={() => onSubmit(controlValue)} />
    </Container>
  );
};
